import React from 'react'
import './RoadMap.css'
import Map from './Map'
import { road, footer } from './../../constants'
import SocialMedia from "./SocialMedia";
export default function RoadMap() {

    const links_1 = road.block1.links.map(l => {
        return (
            <div className='footer__link'>{l}</div>
        )
    })
    const links_2 = road.block2.links.map(l => {
        return (
            <div className='footer__link'>{l}</div>
        )
    })
    return (
        <div className='roadMap'>
            <div className='roadMap__container'>

                {/* <div className='divider' ></div> */}
                {/*<div className="footer__blocks__left">*/}
                {/*    <div className='footer__blocks_col'>*/}
                {/*        <div className="footer__blocks_two">*/}
                {/*            <div className='footer__blocks_1'>*/}
                {/*                /!*{road.block1.title}*!/*/}
                {/*                {links_1}*/}
                {/*            </div>*/}
                {/*            <div className='footer__blocks_2'>*/}
                {/*                /!*{road.block2.title}*!/*/}
                {/*                {links_2}*/}
                {/*            </div>*/}
                {/*        </div>*/}

                {/*        <div className='footer__social__media'>*/}
                {/*            <h1>socilamedia</h1>*/}
                {/*        </div>*/}

                {/*    </div>*/}
                    {/*<div className='footer__blocks_3'>*/}
                    {/*    <Map />*/}
                    {/*</div>*/}
                {/*</div>*/}
                <SocialMedia/>



                <div className='footer__copyright'>
                    {footer.copyright}
                </div>
            </div>
        </div>
    )
}
